import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=5ade1e4a&scoped=true"
import script from "./Match.vue?vue&type=script&lang=ts"
export * from "./Match.vue?vue&type=script&lang=ts"
import style0 from "./match.css?vue&type=style&index=0&id=5ade1e4a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ade1e4a",
  null
  
)

export default component.exports